import { Link, useLocation } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useUserPermissions } from '../contexts/UserPermissionsContext';

function Sidebar({ collapsed }) {
  const location = useLocation();
  const currentPath = location.pathname;
  const { isAdmin, isEditor } = useUserPermissions();

  const menuItems = [
    {
      id: 'dashboard',
      path: '/dashboard',
      label: 'Dashboard',
      icon: 'bi-bar-chart-fill',
      requiresAdmin: true,
    },
    {
      id: 'users',
      path: '/admin/users',
      label: 'User Management',
      icon: 'bi-people-fill',
      requiresAdmin: true,
    },
    {
      id: 'reports',
      path: '/reports',
      label: 'Reports',
      icon: 'bi-graph-up',
      requiresAdmin: true,
    },
    {
      id: 'settings',
      path: '/settings',
      label: 'Settings',
      icon: 'bi-gear-fill',
      requiresAdmin: true,
    },
  ];

  const visibleMenuItems = menuItems.filter((item) => {
    if (item.requiresAdmin) return isAdmin;
    if (item.requiresEditor) return isEditor || isAdmin;
    return true;
  });

  const renderMenuItem = (item) => {
    const linkContent = (
      <Link
        to={item.path}
        className={`sidebar-nav-link ${
          currentPath === item.path ? 'active' : ''
        }`}
      >
        <span className="sidebar-nav-icon"><i className={`bi ${item.icon}`}></i></span>
        <span className="sidebar-nav-text">{item.label}</span>
      </Link>
    );

    if (collapsed) {
      return (
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip>{item.label}</Tooltip>}
        >
          {linkContent}
        </OverlayTrigger>
      );
    }

    return linkContent;
  };

  return (
    <div className={`sidebar ${collapsed ? 'collapsed' : ''}`}>
      <ul className="sidebar-nav">
        {visibleMenuItems.map((item) => (
          <li key={item.id} className="sidebar-nav-item">
            {renderMenuItem(item)}
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Sidebar;
